import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaProfileMenuRegistry = {
    personalize_nebulaProfile: {
        label: "Nebula Profile",
        link: PAGE_URL.NEBULA_PROFILE_PAGE,
        key: PAGE_URL.NEBULA_PROFILE_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaProfileMenuRegistry;
